import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiWrapper } from '../../types/utils';
import { CreateMenuSections } from '../../types';

export class JCreateMenuApi extends JBaseApi {
    public getMenuSections(
        idSpot?: number,
        options?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<CreateMenuSections>> {
        const params: { idSpot?: number } & OF = {
            o: 'jamespot',
            f: 'createMenuSections',
        };
        if (idSpot) {
            params.idSpot = idSpot;
        }
        return this.network.post(params, options?.signal);
    }
}
